export default {
  partnerContent: {
    id: 'buyback_no_offer_recycling_partner_info_block_content',
    defaultMessage:
      '{collector, html} organizes the collection of devices which are then sent directly to {recycler, html}, specialists in sorting devices and giving them second lives. ',
  },
  partnerName: {
    id: 'buyback_no_offer_recycling_partner_info_block_name',
    defaultMessage: 'Ecosystem',
  },
  recyclerName: {
    id: 'buyback_no_offer_recycling_partner_info_block_org_name',
    defaultMessage: 'Emmaüs France',
  },
}
